import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";

const Contact = ({ toggleMode, mode }) => {
  return (
    <>
      <Header mode={mode} toggleMode={toggleMode} />

      <main className="mb-5">
        <div className="container px-4 px-md-0">
          <div className="row">
            <div className="offset-lg-2 col-lg-8">
              <h2 className="mb-2">Contact</h2>

              <p className="mb-5">
                Do you have a question or a special request? We'd love to hear
                from you! Please take a moment to fill out the form below, and
                the GameStrike team will be in touch with you as soon as
                possible.
              </p>

              <p className="text-lg-end">*Required</p>

              <form>
                <div className="row mb-3">
                  <label
                    for="FirstName"
                    className="col-lg-3 col-form-label col-form-label-lg"
                  >
                    First Name*
                  </label>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      ID="FirstName"
                      className="form-control form-control-lg"
                      placeholder="Enter your first name"
                      MaxLength="50"
                      aria-required="true"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <label
                    for="LastName"
                    className="col-lg-3 col-form-label col-form-label-lg"
                  >
                    Last Name*
                  </label>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      ID="LastName"
                      className="form-control form-control-lg"
                      placeholder="Enter your last name"
                      MaxLength="50"
                      aria-required="true"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <label
                    for="CompanyName"
                    className="col-lg-3 col-form-label col-form-label-lg"
                  >
                    Company Name
                  </label>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      ID="CompanyName"
                      className="form-control form-control-lg"
                      placeholder="Enter your company name."
                      MaxLength="100"
                    />
                  </div>
                </div>

                <div className="row d-none mb-3">
                  <label
                    for="Zip"
                    className="col-lg-3 col-form-label col-form-label-lg"
                  >
                    Zip Code
                  </label>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      ID="Zip"
                      className="form-control form-control-lg"
                      placeholder="Enter your ZIP"
                      MaxLength="15"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <label
                    for="JobTitle"
                    className="col-lg-3 col-form-label col-form-label-lg"
                  >
                    Job Title
                  </label>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      ID="JobTitle"
                      className="form-control form-control-lg"
                      placeholder="Enter your job title"
                      MaxLength="100"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <label
                    for="Email"
                    className="col-lg-3 col-form-label col-form-label-lg"
                  >
                    Email*
                  </label>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      ID="Email"
                      className="form-control form-control-lg"
                      placeholder="Enter your email address"
                      MaxLength="320"
                      aria-required="true"
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <label
                    for="InquiryType"
                    className="col-lg-3 col-form-label col-form-label-lg"
                  >
                    Inquiry Type*
                  </label>
                  <div className="col-lg-9">
                    <select
                      ID="InquiryType"
                      className="form-select form-select-lg"
                      aria-required="true"
                    >
                      <option Value="">Select an option</option>
                      <option>Advertising Inquiry</option>
                      <option>News Suggestion(s)</option>
                      <option>General Inquiry</option>
                    </select>
                  </div>
                </div>

                <div className="row mb-3">
                  <label
                    for="Message"
                    className="col-lg-3 col-form-label col-form-label-lg"
                  >
                    Message*
                  </label>
                  <div className="col-lg-9">
                    <textarea
                      type="text"
                      ID="Message"
                      className="form-control form-control-lg"
                      placeholder="Type your message here"
                      Rows="4"
                      MaxLength="1000"
                      aria-required="true"
                    />
                  </div>
                </div>
                <div className="row">
                  <div class="d-grid col-lg-4 offset-lg-3">
                    <input
                      type="submit"
                      ID="Button1"
                      Text="Submit"
                      className="btn btn-dark btn-lg"
                      OnClick="Button1_Click"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Contact;
